import script from "./DateInputMask.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateInputMask.vue?vue&type=script&setup=true&lang=ts"

import "./DateInputMask.vue?vue&type=style&index=0&id=0a22d77e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a22d77e"]])

export default __exports__